import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/ResourcesPage.css";
import FaqSection from "./parts/FaqSection";

const ResourcesPage = () => {
    const [resources, setResources] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [downloadingResources, setDownloadingResources] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        // Check if user has submitted the form
        const hasSubmittedForm = localStorage.getItem("brandBounceFormSubmitted");

        if (!hasSubmittedForm) {
            // Redirect to the form page if user hasn't submitted
            navigate("/resources-form");
            return;
        }

        // Fetch the resources data
        fetch("/resources/brand-bounce-resources.json")
            .then(response => response.json())
            .then(data => {
                setResources(data.files || []);
                setIsLoading(false);
            })
            .catch(error => {
                console.error("Error loading resources:", error);
                setIsLoading(false);
            });
    }, [navigate]);

    const handleDownload = (resourceName) => {
        // Set loading state for the specific resource
        setDownloadingResources(prev => ({ ...prev, [resourceName]: true }));

        // Fetch the JSON file
        fetch(`/resources/${resourceName}.json`)
            .then(response => response.blob())
            .then(blob => {
                // Create a URL for the blob
                const url = URL.createObjectURL(blob);

                // Create a temporary link element
                const link = document.createElement("a");
                link.href = url;
                link.download = `${resourceName}.json`; // Set the download filename

                // Append the link to the body
                document.body.appendChild(link);

                // Click the link to trigger the download
                link.click();

                // Clean up
                document.body.removeChild(link);
                URL.revokeObjectURL(url);

                // Reset loading state for this resource
                setDownloadingResources(prev => ({ ...prev, [resourceName]: false }));
            })
            .catch(error => {
                console.error("Error downloading resource:", error);
                // Reset loading state for this resource
                setDownloadingResources(prev => ({ ...prev, [resourceName]: false }));
                // Show an error message to the user
                alert("There was an error downloading the resource. Please try again.");
            });
    };

    if (isLoading) {
        return (
            <div className="resources-loading">
                <div className="loader"></div>
                <p>Loading resources...</p>
            </div>
        );
    }

    return (
        <div className="resources-container">
            <h1 className="resources-title">Brand Bounce Resources</h1>
            <p className="resources-description">
                Thank you for joining our mailing list! Here are the resources you can download.
            </p>

            <div className="resources-list">
                {resources.map((resource, index) => (
                    <div key={index} className="resource-card">
                        <h2 className="resource-title">{resource.title}</h2>
                        <p className="resource-description">{resource.description}</p>
                        <button 
                            onClick={() => handleDownload(resource.name)} 
                            className="download-button"
                            disabled={downloadingResources[resource.name]}
                        >
                            {downloadingResources[resource.name] ? 'Downloading...' : 'Download Resource'}
                        </button>
                    </div>
                ))}
            </div>

            <FaqSection />
        </div>
    );
};

export default ResourcesPage;
